
import { Component, Mixins } from "vue-property-decorator";
import BaseMixin from "@/views/base/base.mixin";
import ChangePassword from "@/views/base/change-password.vue";
import RegisterUser from "@/views/base/register-user.vue";
import {
  ClientDDL
} from "./base.types";

@Component({
  components: {
    ChangePassword,
    RegisterUser
  }
})
export default class Header extends Mixins(BaseMixin) {
  changePasswordShow = false;
  registerUserShow = false;

  async mounted() {
    await this.$store.dispatch("Base/fetchClientInfo", this.user?.id ?? 0);
  }

  async onClientSelect(clientDDL: ClientDDL) {
    this.$store.commit("Base/updateField", {
      path: "selectedClientDDL",
      value: clientDDL
    });
  }

  showChangePassword() {
    this.changePasswordShow = true;
  }

  showRegisterUser() {
    this.registerUserShow = true;
  }

  async logout() {
    await this.$store.dispatch("Authenticate/logout");
  }
}
